import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { formatKeywordTerms, parseKeywordTerms } from '../utils/keywordTerms';

const KeywordSearchInput = forwardRef(function KeywordSearchInput({ query, onChange, enabled }, ref) {
  const [draft, setDraft] = useState('');
  const [error, setError] = useState('');
  const lastQuery = useRef(query);
  const input = useRef(null);
  const terms = parseKeywordTerms(query);
  useEffect(() => {
    if (lastQuery.current !== query) { setDraft(''); setError(''); lastQuery.current = query; }
  }, [query]);
  const changeQuery = value => { lastQuery.current = value; onChange(value); };
  const commit = () => {
    if (!enabled || !draft.trim()) return query;
    const next = [...terms];
    if (!next.includes(draft.trim())) next.push(draft.trim());
    const value = formatKeywordTerms(next);
    if (next.length > 20 || value.length > 500) { setError('Najviše 20 pojmova i ukupno 500 znakova.'); return null; }
    changeQuery(value);
    setDraft('');
    setError('');
    return value;
  };
  useImperativeHandle(ref, () => ({ commit }));
  return <div className={`search-input-wrap ${enabled ? 'keyword-input-wrap' : ''}`} onClick={() => input.current?.focus()}>
    {enabled && terms.map((term, index) => <span className="search-keyword-chip" key={`${index}-${term}`}>
      <span>{term}</span><button type="button" aria-label={`Ukloni pojam ${term}`} onClick={event => { event.stopPropagation(); changeQuery(formatKeywordTerms(terms.filter((_, i) => i !== index))); }}>×</button>
    </span>)}
    <input ref={input} type="text" aria-label={enabled ? 'Dodaj ključnu riječ ili frazu' : 'Pretraga naslova'}
      value={enabled ? draft : query} maxLength={500} autoComplete="off" placeholder={enabled ? (terms.length ? 'Dodaj pojam…' : 'Pojam + Enter…') : 'Pretraži po naslovu…'}
      onChange={event => enabled ? setDraft(event.target.value) : changeQuery(event.target.value)}
      onKeyDown={event => {
        if (enabled && event.key === 'Enter' && !event.nativeEvent.isComposing) { event.preventDefault(); commit(); }
        if (enabled && event.key === 'Backspace' && !draft && terms.length) changeQuery(formatKeywordTerms(terms.slice(0, -1)));
      }} />
    {error && <span className="keyword-input-error" role="alert">{error}</span>}
  </div>;
});
export default KeywordSearchInput;
